














import { Component, Prop, Vue } from "vue-property-decorator";
import { DebugHelper } from "@/helper/debugHelper";

import CustomInput from '@/commonComponents/customInput/customInput.vue';
import ValueUp from './resources/valueUp.vue';
import ValueDown from './resources/valueDown.vue';

import * as def from "@/definitions";

@Component({
  components: {
        CustomInput,
        ValueUp,
        ValueDown
    }
})
export default class ValueEdit extends Vue 
{
    // タグ
    @Prop() tag! : string;
    // 設定タイプ
    // normal: 通常
    // degrees: 角度
    @Prop() type! : string;
    // 設定値
    @Prop() value! : number;
    // 前置
    @Prop({ default : "" }) prefix! : string;
    // 単位
    @Prop() unit! : string;
    // 単位の位置(trueだったら数字の前に表示される)
    @Prop({ default: false }) isUnitBefore! : boolean;
    // 数値にプラスマイナスを付与する
    @Prop({ default: false }) isPlusMinus! : boolean;
    // 増減値
    @Prop({ default: 1 }) delta! : number;
    // 最大値
    @Prop() max! : number;
    // 最小値
    @Prop() min! : number;
    // 小数点以下桁数
    @Prop() digits! : number;
    // 空白にするか
    @Prop({ default: false }) isBlank! : boolean;

    // ±符号
    private get plusMinus()
    {
        if(!this.isPlusMinus) { return ""; } 

        if(this.value < -0.00001) { return ""; }
        if(this.value > 0.00001) { return "+"; }
        return "±";
    }

    // 長押し
    private pressed = false;
    private pressedDuration = 0;
    private timers = new Array();
    private isChanging = false;

    private onClick(kind)
    {
        var value = kind == "up" ? Number(this.value) + Number(this.delta) : Number(this.value) - Number(this.delta);
        var fix = this.fixValue(this.fixDegreesToInt(value, kind));
        if(fix != this.value)
        {
            // 値変更完了イベント
            this.$emit("changedValue", fix, this.tag);
        }
    }

    private onPress(kind)
    {
        this.pressed = true;
        this.timers.push(setInterval(() => 
        {
            if (this.pressed) 
            {
                if (this.pressedDuration > 3)
                {
                    var value = kind == "up" ? Number(this.value) + Number(this.delta) : Number(this.value) - Number(this.delta);
                    var fix = this.fixValue(this.fixDegreesToInt(value, kind));
                    if(fix != this.value)
                    { 
                        // 値変更中イベント
                        this.$emit("changingValue", fix, this.tag);
                        this.isChanging = true;
                    }
                }
                this.pressedDuration++;
            }
        }, 100));
    }

    private resetPress() 
    {
        this.pressed = false;
        this.pressedDuration = 0;
        this.timers.forEach(timer => 
        {
            clearInterval(timer);
        });

        if(this.isChanging)
        {
            // 値変更完了イベント
            this.$emit("changedValue", Number(this.value), this.tag);
        }
        this.isChanging = false;
    }

    private onSetValue(value)
    {
        var fix = this.fixValue(value);
        if(fix != this.value)
        {
            // 値変更完了イベント
            this.$emit("changedValue", fix, this.tag);
        }
    }

    private fixValue(value : number) : number
    {
        var fix : number = value;
        if(this.type == "degrees")
        {
            DebugHelper.trace(typeof(fix));
            while(fix > 180) { fix -= 360; }
            while(fix < -180) { fix += 360; }
            DebugHelper.trace(typeof(fix));
        }
        else
        {        
            if(fix < Number(this.min)) { fix = this.min; }
            if(fix > Number(this.max)) { fix = this.max; }
        }
        return fix;
    }

    private fixDegreesToInt(value : number, kind : string) : number
    {
        var fix = value;
        if(this.type == "degrees")
        {
            if(Math.floor(value) != value)
            {
                // 小数点以下が存在する
                if(kind == "up")
                {
                    if(value >= 0) { fix = Math.floor(value); }
                    else { fix = -Math.ceil(-value); }
                }
                else
                {
                    if(value >= 0) { fix = Math.ceil(value); }
                    else { fix = -Math.floor(-value); }
                }
            }
        }
        return fix;
    }

    private onClickInput()
    {
        // クリックイベント
        this.$emit("clicked");
    }

    tabKeyDown(event, isShiftKeyDown){
        this.$emit("tabKeyDown", event, isShiftKeyDown);        
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
}
